import { render, staticRenderFns } from "./LinkTag.vue?vue&type=template&id=7d10733a&scoped=true&lang=pug"
import script from "./LinkTag.vue?vue&type=script&lang=js"
export * from "./LinkTag.vue?vue&type=script&lang=js"
import style0 from "./LinkTag.vue?vue&type=style&index=0&id=7d10733a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d10733a",
  null
  
)

export default component.exports